<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click="$emit('cancel')">
        <div class="modal-container" @click.stop>
          <div class="modal-body">
            <b-row v-if="!submittedSuccessfully">
              <b-col class="alert alert-warning">
                You are about to reactivate the demand and
                <strong>permanently</strong> disable the assigned purchase offer.<br />
                <br />
                <strong>Do you want to proceed ?</strong>
              </b-col>
            </b-row>
            <b-col v-else class="text-center">
              <div class="alert alert-success alert-offer-value-success">
                <b-iconstack scale="1.5">
                  <b-icon stacked icon="circle-fill"></b-icon>
                  <b-icon stacked icon="check" variant="white" scale="0.8"></b-icon>
                </b-iconstack>
                Successfully reactivated demand<br /><br />
                <b-button variant="success" @click="$emit('cancel')">
                  <b-icon-x/> Close
                </b-button>
              </div>
            </b-col>
            <b-col cols="12" v-if="error.failPurchaseOffer.isError === true" class="text-left mt-3">
              <div class="alert alert-danger" role="alert">
                Something went wrong. If this problem persists, please contact the IT team. Add the following details to
                better pinpoint the problem:<br />
                Code: <strong>{{ error.failPurchaseOffer.code }}</strong
                ><br />
                Message: <strong>{{ error.failPurchaseOffer.message }}</strong>
              </div>
            </b-col>
          </div>
          <div class="modal-footer" v-if="!submittedSuccessfully">
            <b-button variant="danger" class="mr-auto" @click="$emit('cancel')">No</b-button>
            <b-button variant="success" @click="failPurchaseOffer()">Yes</b-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import constants from 'src/constants/constants';
import apiAuth from 'src/clients/apiAuth';

export default {
  name: 'AdminAcceptedPurchaseOfferFailDialog',
  props: ['purchaseOffer'],
  data: function() {
    return {
      currentlySending: false,
      submittedSuccessfully: false,
      error: {
        failPurchaseOffer: {
          isError: false,
          code: null,
          message: '',
        },
      },
    };
  },
  methods: {
    failPurchaseOffer() {
      let options = {
        method: 'post',
        url:
          constants.url.offerService.baseUrl +
          constants.url.offerService.api.purchaseOffers.fail +
          '/' +
          this.purchaseOffer.purchaseOfferId,
      };
      this.currentlySending = true;
      this.resetError('failPurchaseOffer');
      apiAuth(options)
        .then(() => {
          this.submittedSuccessfully = true;
          this.currentlySending = false;
          this.$emit('purchase-offer-failed');
        })
        .catch((error) => {
          this.setError(
            'failPurchaseOffer',
            error.response.status,
            error.response.data.message + ' /  Purchase Offer ID: ' + this.purchaseOffer.purchaseOfferId,
          );
          console.log(error);
          this.currentlySending = false;
        });
    },
    resetError(errorKey) {
      this.error[errorKey].isError = false;
      this.error[errorKey].code = null;
      this.error[errorKey].message = '';
    },
    setError(errorKey, code, message) {
      this.error[errorKey].isError = true;
      this.error[errorKey].code = code;
      this.error[errorKey].message = message;
    },
  },
};
</script>

<style lang="scss" scoped></style>
